import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { GridSize } from '@material-ui/core/Grid'
import React, { FC, useContext } from 'react'
import { ProductContext } from '../ListingDetailsPage'

import PropertiesContainer from './PropertiesContainer'
import { PropertiesHeader } from './PropertiesHeader'

interface PropertiesEditableProps {
    xs?: GridSize
    clearAllSelection?: () => void
}

export const PropertiesEditable: FC<PropertiesEditableProps> = ({
    clearAllSelection,
}) => {
    const {
        properties,
        selectedData,
        isPremiumAuthorized,
        // @ts-ignore type is in the ListingDetail Type but is being flagged by ts
        product: { type },
    } = useContext(ProductContext)

    return (
        <GridContainer data-testid="PropertiesEditable">
            <PropertiesHeader
                clearAllSelection={clearAllSelection ?? (() => {})}
                isPremiumAuthorized={isPremiumAuthorized}
                listingType={type}
            />
            <PropertiesContainer
                properties={properties ?? {}}
                selectedData={selectedData ?? {}}
                mode="edit"
                listingType={type}
            />
        </GridContainer>
    )
}
